<div
  class="offcanvas offcanvas-bottom offcanvas-body"
  tabindex="-1"
  id="moreActionBottom"
  aria-labelledby="offcanvasBottomLabel"
>
  <div class="offcanvas-header p-0">
    <h5 class="offcanvas-title lg-header-text" id="offcanvasBottomLabel">{{ header }}</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body p-0 small" style="padding: 0">
    <div class="d-flex flex-column gap-3 mt-3">
            <button class="action-btn btn-skip" (click)="onSkipAction()">Skip Item</button>
    <!-- Report Issue Button -->
    <button class="action-btn btn-report">
      <img
        _ngcontent-ng-c812888469=""
        src="assets/images/icons/red-alert.svg"
        alt="alert-triangle"
        class="alert-image"
      />
      Report Issue
    </button>
    </div>
    <!-- Skip Item Button -->

  </div>

  <!-- <div class="offcanvas-bottom small">

  </div> -->
</div>
